import { Component } from 'react';
import Fluide from '../../../containers/Fluide/Fluide'
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { Button } from '@mui/material';
import logo from '../../../images/qr-code-icon.png';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ValidateIcon from '@mui/icons-material/Check';
import { withStyles } from '@mui/styles';
import { TYPING_TIMEOUT } from '../../../constants'
import { getCurrentFunctionName } from '../../../performanceModeManager';
import TextFieldWithTypingTimeout from '../../Input/TextFieldWithTypingTimeout';

const styles = {
    appBar: {
        position: 'relative',
        marginBottom: '10px',
    },
    flex: {
        flex: 1,
    },
};

class InterventionProdlotField extends Component {

    constructor(props) {
        super(props);

        this.state = {
            open: false,
            selectLiquidBottleCode: props.value.value_text,
            timeout: TYPING_TIMEOUT,
            typedJustNow: false,
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {

        let state = { ...prevState }
        if (state.typedJustNow)
            return state;

        let currentValue = nextProps.value.value_text;
        state.selectLiquidBottleCode = currentValue;

        return state;
    }

    onClick() {
        this.setState({
            open: true
        })
    }

    close() {
        this.setState({
            open: false
        })
    }

    selectLiquidBottle(liquidBottleCode) {
        this.setState({
            selectLiquidBottleCode: liquidBottleCode
        })

        let fieldValue = this.props.value;
        fieldValue.value_text = liquidBottleCode
        this.props.fieldValueChange(fieldValue);
        this.close();
    }

    shouldComponentUpdate(nextProps, nextState) {
        let codeChange = this.state.selectLiquidBottleCode !== nextState.selectLiquidBottleCode
        let modalStateChange = this.state.open !== nextState.open
        return codeChange || modalStateChange
    }

    visualizeLiquidBottle(liquidBottleCode) {
        this.setState({
            liquidBottleCode
        })
    }

    validateVisualizingLiquidBottle() {
        this.selectLiquidBottle(this.state.liquidBottleCode);
        this.setState({
            liquidBottleCode: "",
        })
    }

    cancelVisualizingLiquidBottle() {
        this.setState({
            liquidBottleCode: "",
        })
    }

    handleChange(value) {
        let fieldValue = this.props.value;
        fieldValue.value_text = value;
        this.props.fieldValueChange(fieldValue);
        this.setState({
            typedJustNow: false
        })
    }

    render() {
        console.perfLog(getCurrentFunctionName());
        const { classes } = this.props;

        return (
            <div className="row">
                <div className="col-lg-10 col-md-10 col-sm-8 col-12 without-side-padding">
                    <TextFieldWithTypingTimeout value={this.state.selectLiquidBottleCode} onValueChange={this.handleChange.bind(this)}
                        {...this.props.inputProperties} label={this.props.model.name}
                        className={this.props.inputProperties.className + " full_size control-margin-top"} />
                </div>
                <div className="col-lg-2 col-md-2 col-sm-4 col-12 control-inline-btn">
                    <Button variant="contained" size="small" onClick={this.onClick.bind(this)} {...this.props.inputProperties}>
                        <img src={logo} alt="QR code" width={32} height={32} />
                    </Button>
                </div>
                <Dialog open={this.state.open} onClose={this.handleClose} fullScreen aria-labelledby="form-dialog-title">
                    <AppBar className={classes.appBar} elevation={0}>
                        <Toolbar>
                            <IconButton color="inherit" onClick={this.close.bind(this)} aria-label="Close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" color="inherit" className={classes.flex}>
                                {"Fluide"}
                            </Typography>
                            <IconButton color="inherit" onClick={this.validateVisualizingLiquidBottle.bind(this)} aria-label="Validate">
                                <ValidateIcon />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <Toolbar/>
                    <DialogContent className="without-side-padding">
                        <Fluide modalMode selectLiquidBottle={this.selectLiquidBottle.bind(this)}
                            visualizeLiquidBottle={this.visualizeLiquidBottle.bind(this)}
                            cancelVisualizingLiquidBottle={this.cancelVisualizingLiquidBottle.bind(this)} />
                    </DialogContent>
                </Dialog>
            </div>
        )
    }
}

export default withStyles(styles)(InterventionProdlotField);
